import z from 'zod'

export const listSelectionFormSchema = z.object({
  list: z.string().nonempty(),
})

export type ListSelectionFormValues = z.infer<typeof listSelectionFormSchema>
